import pb from '../lib/pocketbase';

// Get all activo drops with pagination
export async function getActivoDrops(page = 1, perPage = 50) {
  try {
    const response = await pb.collection('activo_drop').getList(page, perPage, {
      expand: 'user,activo',
      sort: '-created'
    });
    
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.page,
      perPage: response.perPage
    };
  } catch (error) {
    console.error('Error fetching activo drops:', error);
    throw error;
  }
}

// Get a single activo drop by ID
export async function getActivoDrop(id) {
  try {
    const response = await pb.collection('activo_drop').getOne(id, {
      expand: 'user,activo'
    });
    return response;
  } catch (error) {
    console.error('Error fetching activo drop:', error);
    throw error;
  }
}

// Create a new activo drop
export async function createActivoDrop(data) {
  try {
    const response = await pb.collection('activo_drop').create(data);
    return response;
  } catch (error) {
    console.error('Error creating activo drop:', error);
    throw error;
  }
}

// Update an existing activo drop
export async function updateActivoDrop(id, data) {
  try {
    const response = await pb.collection('activo_drop').update(id, data);
    return response;
  } catch (error) {
    console.error('Error updating activo drop:', error);
    throw error;
  }
}

// Delete an activo drop
export async function deleteActivoDrop(id) {
  try {
    await pb.collection('activo_drop').delete(id);
    return true;
  } catch (error) {
    console.error('Error deleting activo drop:', error);
    throw error;
  }
}

// Get activo drops by user (user)
export async function getActivoDropsByUser(userId) {
  try {
    const response = await pb.collection('activo_drop').getList(1, 100, {
      filter: `user = "${userId}"`,
      expand: 'user,activo',
      sort: '-created'
    });
    return response.items;
  } catch (error) {
    console.error('Error fetching activo drops by user:', error);
    throw error;
  }
}

// Get activo drops by location (within a certain radius)
export async function getActivoDropsByLocation(lat, lng, radius = 0.01) {
  try {
    // This would need to be implemented based on your specific location storage format
    // For now, returning all drops
    const response = await pb.collection('activo_drop').getList(1, 100, {
      expand: 'user,activo',
      sort: '-created'
    });
    return response.items;
  } catch (error) {
    console.error('Error fetching activo drops by location:', error);
    throw error;
  }
}
